let hasGesture = false;
let pendingPattern = null;

function flushPendingPattern() {
  if (!pendingPattern) {
    return;
  }
  const pattern = pendingPattern;
  pendingPattern = null;
  try {
    navigator.vibrate(pattern);
  } catch (error) {
    console.warn('Unable to vibrate', error);
  }
}

if (typeof window !== 'undefined') {
  const GESTURE_EVENTS = ['pointerdown', 'touchstart', 'keydown'];
  const handleGesture = () => {
    hasGesture = true;
    flushPendingPattern();
  };
  for (const eventName of GESTURE_EVENTS) {
    window.addEventListener(eventName, handleGesture, { capture: true });
  }
}

export function overdueVibrationPattern(cycles) {
  const parts = [];
  for (let i = 0; i < cycles; i += 1) {
    parts.push(200, 250, 200, 250, 200, 1000);
  }
  return parts;
}

export function vibrate(pattern) {
  if (
    typeof navigator === 'undefined' ||
    typeof navigator.vibrate !== 'function' ||
    typeof document === 'undefined' ||
    document.visibilityState !== 'visible'
  ) {
    return;
  }

  if (!hasGesture) {
    pendingPattern = pattern;
    return;
  }

  try {
    navigator.vibrate(pattern);
  } catch (error) {
    console.warn('Unable to vibrate', error);
  }
}

export function stopVibration() {
  if (typeof navigator === 'undefined' || typeof navigator.vibrate !== 'function') {
    return;
  }

  try {
    navigator.vibrate(0);
  } catch (error) {
    console.warn('Unable to stop vibration', error);
  }
}